import React from 'react'
import Footer from '../components/Footer'

const BrandPage = () => {
    return (
        <div className='bg-black'>
            {/* <Header /> */}
            <section>
                <div className="about-us-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-12 text-center">
                                <div className="about-us-buszzing-universe">
                                    <p>Coming Soom</p>
                                </div>
                                <p>we are coming soon</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

        </div>
    )
}

export default BrandPage
